import { type UseQueryResult, keepPreviousData, useQuery } from '@tanstack/react-query';

import api from '@/api/axios';
import type { AuditSelfAssessmentResponse } from '@/types';
import { shouldRetryRequest } from '@/utils/shouldRetryRequest';

const fetchSelfAssessments = async (
  supplierId: string,
  limit: number,
  offset: number,
): Promise<AuditSelfAssessmentResponse> => {
  const { data } = await api.get<AuditSelfAssessmentResponse>(
    `/suppliers/${supplierId}/audit-cases`,
    {
      params: {
        limit,
        offset,
      },
    },
  );

  return data;
};

export const useGetSelfAssessments = (
  supplierId: string,
  limit: number = 10,
  offset: number = 0,
): UseQueryResult<AuditSelfAssessmentResponse, unknown> => {
  return useQuery({
    queryKey: ['self-assessments', limit, offset],
    queryFn: () => fetchSelfAssessments(supplierId, limit, offset),
    placeholderData: keepPreviousData,
    retry(failureCount, error) {
      return shouldRetryRequest(failureCount, error);
    },
  });
};
